<ion-text color="dark">
  <ul [ngClass]="['list-' + node?.style]">
    <li *ngFor="let i of node?.items" [innerHTML]="i"></li>
  </ul>
</ion-text>
